// Typelizer digest fc38c725835712cf25d3f6361f81a324
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
export { default as currentAccounts } from './CurrentAccountsController'
export { default as emailVerifications } from './EmailVerificationsController'
export { default as pages } from './PagesController'
export { default as passwords } from './PasswordsController'
export { default as sessions } from './SessionsController'
export { default as signups } from './SignupsController'

import _currentAccounts from './CurrentAccountsController'
import _passwords from './PasswordsController'
import _emailVerifications from './EmailVerificationsController'
import _pages from './PagesController'
import _sessions from './SessionsController'
import _signups from './SignupsController'

export const currentAccount = _currentAccounts.update
export const editPassword = _passwords.edit
export const emailVerification = _emailVerifications.show
export const home = _pages.home
export const newPassword = _passwords.new
export const newSession = _sessions.new
export const newSignup = _signups.new
export const password = _passwords.update
export const root = _pages.root
export const session = _sessions.destroy
export const signup = _signups.create
